import { Callout } from '../../Callout/Callout';
import { Smile } from '../../svg/Smile/Smile';

type TitleSectionProps = {
  title: string;
  label?: string;
};

function TitleSection({ title, label }: TitleSectionProps) {
  return (
    <div className="text-center z-10">
      {label && (
        <Callout className="select-none mb-2 md:mb-0" data-testid="discover-entry-banner-callout" variant="accent">
          {label}
        </Callout>
      )}
      <div className="flex flex-col items-center gap-2">
        <h4 className="md:heading-2 [&>span]:heading-5 md:[&>span]:heading-4" dangerouslySetInnerHTML={{ __html: title }} />
        <Smile />
      </div>
    </div>
  );
}

export { TitleSection };
export type { TitleSectionProps };
